/**
 * Staff compliance access (spot checks, supervisions, competencies).
 *
 * Spot checks are management QA records (CQC Reg 17/18 evidence), not worker-facing
 * supervision summaries (NICE NG21 1.7.11). Restricted to portal admins at this stage.
 */
export const STAFF_COMPLIANCE_ADMIN_ROLES = ['super_admin', 'admin'];

export function canAccessStaffComplianceAdmin(user) {
  return STAFF_COMPLIANCE_ADMIN_ROLES.includes(user?.role);
}

export function canManageSpotChecks(user) {
  return canAccessStaffComplianceAdmin(user);
}

export function canManageSupervisions(user) {
  return canAccessStaffComplianceAdmin(user);
}

export function canManageCompetencies(user) {
  return canAccessStaffComplianceAdmin(user);
}